import type {ModalsValueType} from '@src/constants/modals.ts';
import type {ModalsState, StateSlice} from '@src/stores/types.ts';

export const setModalsSlice: StateSlice<ModalsState> = set => ({
  activeModal: null,
  showModal: (modal: ModalsValueType | null) =>
    set(
      state => {
        state.modals.activeModal = modal;
      },
      undefined,
      'modals/showModal',
    ),
  hideModal: () =>
    set(
      state => {
        state.modals.activeModal = null;
      },
      undefined,
      'modals/hideModal',
    ),
});
